import { CreateInvoiceIssuerDto, InvoicePaymentType } from '../services/api/sharedTypes/Invoice'

export const getEmptyCreateInvoiceIssuerObject: () => CreateInvoiceIssuerDto = () => {
    return {
        name: '',
        bankAccount: '',
        iban: '',
        swift: '',
        paymentDays: 0,
        address: '',
        companyRegistrationNumber: '',
        valueAddedTaxIdentificationNumber: '',
        invoicedBy: '',
        lastModifiedAt: new Date(),
        imageName: '',
        imageData: new Uint8Array(),
    }
}

export enum InvoiceTab {
    Overview = 'overview',
    Issuers = 'issuers',
}

export enum InvoiceServices {
    OnsiteEvent = 'Zajištění akce, atrakcí, služeb a produkce na místě',
    RentAttractionWithService = 'Pronájem atrakce včetně obsluhy a dopravy',
    RentAttraction = 'Pronájem atrakce',
    RentAttractionWithInstallation = 'Pronájem atrakce s instalací/deinstalací a dopravou',
    Other = 'Ostatní',
}

export const getInvoiceTab = (tab: string) => {
    if (tab === InvoiceTab.Overview) return InvoiceTab.Overview
    if (tab === InvoiceTab.Issuers) return InvoiceTab.Issuers
    return InvoiceTab.Overview
}

export const getInvoiceTabNumber = (tab: InvoiceTab) => {
    if (tab === InvoiceTab.Overview) return 0
    if (tab === InvoiceTab.Issuers) return 1
    return 0
}

export const convertNumberToInvoiceTab = (data: number) => {
    if (data === 0) return InvoiceTab.Overview
    if (data === 1) return InvoiceTab.Issuers
    return InvoiceTab.Overview
}

/**
 * @param services - string of services
 * @returns array of services or empty string if service is not selected
 * @description
 * 1. split services by ', '
 * 2. if servicesArray includes first 2 words from InvoiceServices.OnsiteEvent add it to serviceValues and remove first 3 indexes from servicesArray ( because InvoiceServices.OnsiteEvent contain 2x ',' ) else add empty string
 * 3. if servicesArray[0] is equal to InvoiceServices.RentAttractionWithService add it to serviceValues and remove from servicesArray else add empty string
 * 4. if servicesArray[0] is equal to InvoiceServices.RentAttraction add it to serviceValues and remove from servicesArray else add empty string
 * 5. if servicesArray[0] is equal to InvoiceServices.RentAttractionWithInstallation add it to serviceValues and remove from servicesArray else add empty string
 * 6. add rest of services to serviceValues ( because it is InvoiceServices.Other and can contain ',' ) else add empty string
 * @example
 *  services =
 * 'Zajištění akce, atrakcí, služeb a produkce na místě, Pronájem atrakce včetně obsluhy a dopravy, Testovací služba, Testovací služba 2'
 * serviceValues = [
 * 'Zajištění akce, atrakcí, služeb a produkce na místě',
 * 'Pronájem atrakce včetně obsluhy a dopravy',
 * '',
 * '',
 * 'Testovací služba, Testovací služba 2'
 * ]
 */
export const getServiceValues = (services: string) => {
    const servicesArray = services.split(', ')
    const serviceValues: string[] = []

    // if servicesArray includes first 2 words from InvoiceServices.OnsiteEvent add it to serviceValues and remove first 3 indexes from servicesArray
    if (services.split(' ').slice(0, 2).join(' ') === InvoiceServices.OnsiteEvent.split(' ').slice(0, 2).join(' ')) {
        serviceValues.push(InvoiceServices.OnsiteEvent)
        servicesArray.splice(0, 3)
    } else {
        serviceValues.push('')
    }

    //  if service is equal to InvoiceServices.RentAttractionWithService add it to serviceValues and remove from servicesArray
    if (servicesArray[0] === InvoiceServices.RentAttractionWithService) {
        serviceValues.push(InvoiceServices.RentAttractionWithService)
        servicesArray.splice(servicesArray.indexOf(servicesArray[0]), 1)
    } else {
        serviceValues.push('')
    }

    //  if service is equal to InvoiceServices.RentAttraction add it to serviceValues and remove from servicesArray
    if (servicesArray[0] === InvoiceServices.RentAttraction) {
        serviceValues.push(InvoiceServices.RentAttraction)
        servicesArray.splice(servicesArray.indexOf(servicesArray[0]), 1)
    } else {
        serviceValues.push('')
    }

    //  if service is equal to InvoiceServices.RentAttractionWithInstallation add it to serviceValues and remove from servicesArray
    if (servicesArray[0] === InvoiceServices.RentAttractionWithInstallation) {
        serviceValues.push(InvoiceServices.RentAttractionWithInstallation)
        servicesArray.splice(servicesArray.indexOf(servicesArray[0]), 1)
    } else {
        serviceValues.push('')
    }

    // add rest of services to serviceValues
    if (servicesArray.length > 0) {
        serviceValues.push(servicesArray.join(', '))
    } else {
        serviceValues.push('')
    }
    return serviceValues
}

export const convertInvoicePaymentTypeToString = (paymentType: InvoicePaymentType) => {
    if (paymentType === InvoicePaymentType.Cash) return 'Hotově'
    if (paymentType === InvoicePaymentType.WireTransfer) return 'Převodem'
    return ''
}
